import React from 'react';
import Item from './Item'

const Accordion = ({ items = [] }) => {
    return (
        items.filter(i => i.show !== false).map((item, index) => (
            <Item
                key={`accordion_${index}_${item.title}`}
                {...item}
            />
        ))
    );
}

export default Accordion;